import { takeEvery, put, select, call } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import format from 'date-fns/format';
import * as Constants from '../../actions';

const teeTimeUpdateActions = [
    Constants.TEETIMES_RESPONSE,
    Constants.GOLFERCOUNT_UPDATE,
    Constants.HOLECOUNT_UPDATE,
    Constants.GOLFCART_UPDATE,
    Constants.TIMERANGE_UPDATE,
    Constants.PRICERANGE_UPDATE,
    Constants.RESET_FILTERS
]
const userUiInteractionActions = [
    Constants.GOLFERCOUNT_UPDATE,
    Constants.HOLECOUNT_UPDATE,
    Constants.GOLFCART_UPDATE,
    Constants.TIMERANGE_UPDATE,
    Constants.PRICERANGE_UPDATE,
    Constants.RESET_FILTERS,
    Constants.CALANDER_UPDATE,
    Constants.PAGE_UPDATE,
]

const scrollToTopActions = [
    Constants.PAGE_UPDATE,
]

function* teeTimesUpdate(action) {
    const teetimes = yield select(state => state.filters.matchingTeeTimes)
    yield put({ type: Constants.TEETIMES_FETCHED, payload: teetimes });
    yield put({ type: Constants.CONTENT_UPDATED })
}

function* showingGolferModal(action) {
    yield call(delay, 0)
    yield put({ type: Constants.CONTENT_UPDATED })
}
function* teeTimeSelected(action) {
    const showSelectGolferModal = yield select(state => state.selectedTeeTime.golfers === null)
    if(showSelectGolferModal){
        yield call(delay, 0)
        yield put({ type: Constants.SHOW_GOLFER_MODAL })
    }
}

function* cancelTeeTimeSelected(action){
    yield call(delay, 0)
    yield put({ type: Constants.CONTENT_UPDATED })
}

function* loadMoreTimesMobile(action){
    yield call(delay, 0)
    yield put({ type: Constants.CONTENT_UPDATED })
}

function* mobileDrawerToggled(action){
    yield call(delay, 0)
    yield put({ type: Constants.CONTENT_UPDATED })
}

const getCalanderUpdateHandler = facilityid => function* handleCalanderUpdate(action) {
    const date = format(action.payload, 'YYYY-MM-DD');
    const payload = {
        facilityid,
        dateMin: date,
        dateMax: date
    };
    yield put({ type: Constants.FETCH_TEETIMES, payload })
    yield put({ type: Constants.UNSET_TEETIME_UNAVAILIBLE_ERROR });
}

function* dispatchUnsetTTUError(action){
    yield put({ type: Constants.UNSET_TEETIME_UNAVAILIBLE_ERROR });
}

function* dispatchScrollToTop(action){
    yield put({ type: Constants.SCROLL_TO_TOP });
}

function* filtersSaga(facilityid) {
    /// todo add listener to every filter update that does not include a new api call
    yield takeEvery(teeTimeUpdateActions, teeTimesUpdate);
    yield takeEvery(Constants.TEETIME_SELECTED, teeTimeSelected);
    yield takeEvery(Constants.SHOW_GOLFER_MODAL, showingGolferModal);
    yield takeEvery(Constants.CANCEL_SELECTED_TEETIME,  cancelTeeTimeSelected)
    yield takeEvery(Constants.MOBILE_LOAD_MORE, loadMoreTimesMobile);
    yield takeEvery([Constants.DRAWER_CLOSED, Constants.DRAWER_OPENED], mobileDrawerToggled);
    yield takeEvery(Constants.CALANDER_UPDATE, getCalanderUpdateHandler(facilityid))
    // dispatch hide tee-time unavailible action when user interaction occurs with filters or pagination
    yield takeEvery(userUiInteractionActions, dispatchUnsetTTUError);
    yield takeEvery(scrollToTopActions, dispatchScrollToTop);
}

export default filtersSaga;



// WEBPACK FOOTER //
// ./src/sagas/filters/index.js